(function auditDetailControllerDefinition() {
    'use strict';

    angular.module('Audit')
        .controller('AuditDetailController', [
            '$filter', '$state', '$scope', '$stateParams', 'auditService', 'fileService',
            function auditDetailController($filter, $state, $scope, $stateParams, auditService, fileService) {

                $scope.load = function () {
                    $scope.showError = false;
                    $scope.isArray = angular.isArray;
                    auditService.getById($stateParams.id).then(function (result) {
                        if (result.value.entity && result.value.actionType) {
                            try {
                                $scope.generalData = result.value;
                                $scope.entity = JSON.parse(result.value.entity);
                                $scope.actionType = result.value.actionType.traslatedName;
                                $scope.metadatas = $scope.entity.metadatas;
                                $scope.filelist = $scope.entity.filelist;
                                if ($scope.filelist && $scope.filelist.length > 0) {
                                    $scope.filelist.forEach(function (file) {
                                        var valueAux = file.value.split('>');
                                        file.value = valueAux[0] + ' - ' + fileService.FormatfileSize(valueAux[1]);
                                    });
                                }
                                delete $scope.entity.metadatas;
                                delete $scope.entity.filelist;
                            } catch (e) {
                                $scope.showError = true;
                            }
                        }
                    });
                };

                $scope.goToDetail = function (id) {
                    if ($scope.entity.documentId) {
                        $state.go('document-detail', { id: id });
                    }
                    if ($scope.entity.containerId) {
                        $state.go('document-container-detail', { id: id });
                    }
                    if ($scope.entity.documentsId && $scope.entity.documentsId.length > 0) {
                        var list = $scope.entity.documentsId;
                        for (var i = 0; i < list.length; i++) {
                            if (list[i] == id)
                                $state.go('document-detail', { id: id });
                        }
                    }

                }

                $scope.cancel = function () {
                    $state.goBack();
                };

                $scope.load();
            }
        ]);
})();
